<script lang="ts">
  import type { ColorToken } from '@agapi/ui/panda/tokens';
  import type { DividerStoryblok } from '~/component-types-sb';

  import { storyblokEditable } from "@storyblok/svelte";
  import { Divider } from "@agapi/ui/divider";

  interface Props {
    blok: DividerStoryblok;
  }

  const { blok }: Props = $props();

  const dividerProps = {
    direction: blok.direction || 'horizontal',
    thickness: blok.thickess === 'thin' ? 1 : blok.thickess === 'medium' ? 2 : blok.thickess === 'thick' ? 3 : 1,
    spacing: blok.spacing,
    color: blok.color_variant ? `surface.${blok.color_variant}.border` as ColorToken : undefined,
  };
</script>

<Divider use={[[storyblokEditable, blok]]} {...dividerProps} />
